



import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  currentUser: null,
  error: null,
  loading: false,
};

  const userId = localStorage.getItem("userId")

export const updateJobSeekerAvailability = createAsyncThunk(
  "user/updateJobSeekerAvailability",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}jobseeker/availability`,
        payload,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("jobSeekerToken")}` },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    signinStart: (state) => {
      return { ...state, loading: true, error: false };
    },
    signinSuccess: (state, action) => {
      return {
        ...state,
        loading: false,
        error: false,
        currentUser: action.payload,
      };
    },
    signinFailure: (state, action) => {
      return { ...state, error: action.payload, loading: false };
    },
    updateUser: (state, action) => {
      return { ...state, currentUser: action.payload };
    },
    refreshUser: (state, action) => {
      return { ...state, currentUser: action.payload };
    },
    signoutUser: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateJobSeekerAvailability.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateJobSeekerAvailability.fulfilled, (state, action) => {
        state.loading = false;
        state.currentUser = { ...state.currentUser, ...action.payload };
      })
      .addCase(updateJobSeekerAvailability.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  signinFailure,
  signinStart,
  signinSuccess,
  updateUser,
  signoutUser,
  refreshUser,
} = userSlice.actions;
export default userSlice.reducer;





// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";

// const initialState = {
//   currentUser: null,
//   token: null,
//   error: null,
//   loading: false,
// };

// const userId = localStorage.getItem("userId");

// export const updateJobSeekerAvailability = createAsyncThunk(
//   "user/updateJobSeekerAvailability",
//   async (payload, { rejectWithValue }) => {
//     try {
//       const response = await axios.put(
//         `${process.env.REACT_APP_API_URL}jobseeker/availability`,
//         payload,
//         {
//           headers: { Authorization: `Bearer ${localStorage.getItem("jobSeekerToken")}` },
//         }
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response.data);
//     }
//   }
// );

// const userSlice = createSlice({
//   name: "user",
//   initialState,
//   reducers: {
//     signinStart: (state) => {
//       return { ...state, loading: true, error: false };
//     },
//     // Expects action.payload = { user, token } — update wherever signinSuccess
//     // is dispatched after login to pass both, not just the raw user object.
//     signinSuccess: (state, action) => {
//       return {
//         ...state,
//         loading: false,
//         error: false,
//         currentUser: action.payload.user,
//         token: action.payload.token,
//       };
//     },
//     signinFailure: (state, action) => {
//       return { ...state, error: action.payload, loading: false };
//     },
//     updateUser: (state, action) => {
//       return { ...state, currentUser: action.payload };
//     },
//     refreshUser: (state, action) => {
//       return { ...state, currentUser: action.payload };
//     },
//     setToken: (state, action) => {
//       return { ...state, token: action.payload };
//     },
//     signoutUser: () => {
//       return initialState;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(updateJobSeekerAvailability.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(updateJobSeekerAvailability.fulfilled, (state, action) => {
//         state.loading = false;
//         state.currentUser = { ...state.currentUser, ...action.payload };
//       })
//       .addCase(updateJobSeekerAvailability.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const {
//   signinFailure,
//   signinStart,
//   signinSuccess,
//   updateUser,
//   signoutUser,
//   refreshUser,
//   setToken,
// } = userSlice.actions;
// export default userSlice.reducer;